import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCompare,
  GuideContrast,
  GuideBlockList,
} from "../GuideBlocks.js";

const InternalVsExternalSection = ({ heading, accentIndex = 2, getVisual, getAccent }) => (
  <GuidePanel sectionId="internal-vs-external" heading={heading} accentIndex={accentIndex} getVisual={getVisual} getAccent={getAccent}>
    <GuideLead>
      Understanding the difference between external and internal noise helps you identify what you
      can control.
    </GuideLead>
    <GuideCompare
      leftTitle="External Noise"
      rightTitle="Internal Noise"
      left={
        <GuideBlockList
          items={[
            "Social media",
            "News",
            "Workplace politics",
            "Opinions from others",
            "Constant notifications",
            "Expectations from family or society",
          ]}
        />
      }
      right={
        <GuideBlockList
          items={[
            "Self-doubt",
            "Assumptions",
            "Negative self-talk",
            "Imagined conversations",
            "Catastrophic thinking",
            "Misinterpreting facts",
          ]}
        />
      }
    />
    <GuideContrast
      items={[
        {
          title: "External noise influences you.",
          text: "It shapes your environment and incoming information.",
        },
        {
          title: "Internal noise controls how you interpret it.",
          text: "It determines your emotional and behavioral response.",
        },
      ]}
    />
    <p className="guide-panel__p">
      This distinction matters because the two are managed differently. External noise is reduced by
      changing inputs — fewer notifications, fewer feeds, fewer opinions in the room. Internal noise is
      reduced by examining interpretations: writing down the thought, checking it against evidence, and
      deciding what to do next. You cannot mute the world completely, but you can always test the story
      you are telling about it.
    </p>
  </GuidePanel>
);

export default InternalVsExternalSection;
